import React, {FC} from "react";

import GlossaryTermCard from "view/components/GlossaryTerm";
import {Actions as CreateGlossaryTermActions} from "view/components/GlossaryTerm/GlossaryTermActions";
import {ICategory, IGlossary, ITerm} from "@evennt-tech/api-v2-core";

type RenderGlossaryTermProps = {
  createGlossaryTermActions: (
    term: ITerm
  ) => CreateGlossaryTermActions | undefined;
  term: ITerm;
  glossary: IGlossary;
  categories: ICategory[];
  terms: ITerm[];
  isPrintView?: boolean;
};

const GlossaryTermItem: FC<RenderGlossaryTermProps> = ({
  createGlossaryTermActions,
  glossary,
  categories,
  term,
  terms,
  isPrintView,
}) => {
  if (!term) {
    return null;
  }
  const {id, categoryId} = term;

  const sectionId = `${categoryId}_${id}`;
  return (
    <div>
      <section id={sectionId}>
        <GlossaryTermCard
          term={term}
          categories={categories}
          terms={terms}
          glossary={glossary}
          actions={createGlossaryTermActions(term)}
          key={term.title}
          isPrintView={isPrintView}
        />
      </section>
    </div>
  );
};

export default GlossaryTermItem;
